import { Component, OnInit, inject } from '@angular/core';
import { SessionStorageService } from '../services/session-storage.service';
import { VERSION } from '../../environments/version';
import { Global } from '../models/global.model';

@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.component.html',
  styleUrls: ['./app-footer.component.scss'],
  standalone: false,
})
export class AppFooterComponent implements OnInit {
  private ss = inject(SessionStorageService);

  engine: string;
  ui: string;
  kb: string;
  year: string = new Date().getFullYear().toString();
  globals: Global;
  disclaimer = `The RightBRIDGE&reg; Profiler&reg; presents “bridges” that are suggestions, not recommendations or solicitations. Using RightBRIDGE&reg; is not a substitute for financial professional due diligence. CapitalRock does not offer investment or financial advice and the RightBRIDGE&reg; application is intended to be an analytic tool and is not a replacement for a product prospectus. The information in this tool and report is not guaranteed as accurate or complete. Refer to each product prospectus (when applicable) for specific product information. CapitalRock, LLC is not responsible for any losses or damages resulting from use of the information in this tool or report for any purpose. &copy;Copyright ${this.year} CapitalRock`;
  date = new Date();
  uiVer: string = VERSION.version + '-' + this.date.toISOString();

  ngOnInit() {
    let isInitializing = true;

    // Initial check to see if globals are already set
    const initialGlobals = this.ss.get('globals');
    if (initialGlobals) {
      this.globals = initialGlobals ? initialGlobals : {};
      this.engine = this.globals ? this.globals.Engine : null;
      this.ui =
        this.globals && this.globals.uiconfig ? this.globals.uiconfig : null;
      this.kb = this.globals && this.globals.KB ? this.globals.KB : null;
      this.disclaimer =
        this.globals &&
        this.globals.disclaimers &&
        Array.isArray(this.globals.disclaimers)
          ? this.globals.disclaimers.find(x => x['name'] === 'standard')['copy']
          : this.disclaimer;
      if (this.disclaimer.includes('{year}')) {
        this.disclaimer = this.disclaimer.replace('{year}', this.year);
      }
    }

    // Subscribe to storage changes
    this.ss.storageChangeExternal.subscribe(chng => {
      if (!isInitializing) {
        if (chng.key === 'globals') {
          const localGlobals = this.ss.get('globals');
          if (localGlobals) {
            this.globals = localGlobals ? localGlobals : {};
            this.engine = this.globals ? this.globals.Engine : null;
            this.ui =
              this.globals && this.globals.uiconfig
                ? this.globals.uiconfig
                : null;
            this.kb = this.globals && this.globals.KB ? this.globals.KB : null;
            this.disclaimer =
              this.globals &&
              this.globals.disclaimers &&
              Array.isArray(this.globals.disclaimers)
                ? this.globals.disclaimers.find(x => x['name'] === 'standard')[
                    'copy'
                  ]
                : this.disclaimer;
            if (this.disclaimer.includes('{year}')) {
              this.disclaimer = this.disclaimer.replace('{year}', this.year);
            }
          }
        }
      }
    });

    // Set the flag to false after initialization is complete
    isInitializing = false;
  }
}
